module.exports = function() {
  return new Worker(__webpack_public_path__ + "61426cb19b019a0269d7.worker.js");
};


//////////////////
// WEBPACK FOOTER
// /drone/~/worker-loader/dist/cjs.js!/drone/~/pdfjs-dist/build/pdf.worker.js
// module id = 2720
// module chunks = 2